module.exports = __webpack_public_path__ + "static/img/dd-banner-03.1080e7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/dd-banner-03.png
// module id = pu9G
// module chunks = 1